import i18next from "i18next"

import {
  VUEX_LOCALSTORAGE_DATA_SET
} from '@/store/constants/localStorage'

import {
  VUEX_LOCALIZATION_CHANGE_LANG,
  VUEX_LOCALIZATION_CHANGE_PRODUCT_LANG
} from '@/store/constants/localization'

const state = {
  currentLang: 'en-US',
  fallbackLang: 'en-US',

  productLang: { name: 'English', code: 'en-US' }
}
const getters = {}
const actions = {
  [VUEX_LOCALIZATION_CHANGE_LANG]: ({ commit, dispatch }, langCode) => {
    i18next.changeLanguage(langCode)

    commit(VUEX_LOCALIZATION_CHANGE_LANG, langCode)

    dispatch(
      VUEX_LOCALSTORAGE_DATA_SET,
      { path: 'localization.language', value: langCode }
    )
  },

  [VUEX_LOCALIZATION_CHANGE_PRODUCT_LANG]: ({ commit, dispatch }, langObj) => {
    commit(VUEX_LOCALIZATION_CHANGE_PRODUCT_LANG, langObj)

    dispatch(
      VUEX_LOCALSTORAGE_DATA_SET,
      { path: 'localization.productLanguage', value: langObj }
    )
  }
}
const mutations = {
  [VUEX_LOCALIZATION_CHANGE_LANG]: (state, langCode) => {
    state.currentLang = langCode
  },

  [VUEX_LOCALIZATION_CHANGE_PRODUCT_LANG]: (state, langObj) => {
    state.productLang = langObj
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
